import styles from '../../views/pages/style.module.css'
// import logo from '../../../public/polaris.jpg'
import logo from '../../../src/assets/images/polaris.jpg'

const AuthLayout = ({component}) => {
    
  return (
    <div className={`${styles.bgColor}`}>
        <div className='d-flex justify-content-center align-items-center p-0'>
            <div
                className={`text-white d-none d-md-block`}
            >
                <div className="text-center px-5">
                    <div className='d-flex justify-content-center align-items-center vh-100'>
                        <img 
                        src={logo}
                        alt='logo'
                        className='img-fluid'/>
                    </div>
                </div>
            </div>
        </div>
    </div>

  )
}

export default AuthLayout